/*
 * File: AuthRouteWrapper.jsx
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 10:03 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: April 1, 2025 at 2:17 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';


/**
 * Route Wrapper
 */

export const AuthRouteWrapper = ({
	children, redirect
}) => {

	// Get current user
	const user = useSelector((state) => state.user.value);

	// Get current locale from hook
	const locale = useSelector((state) => state.locale.value);

	// Allow access to component
	return !user || user.is_anonymous === true ? children : <Navigate to={`${locale.localePath}${redirect}`} />;
};


/**
 * Configuration
 */

AuthRouteWrapper.propTypes = {
	children: PropTypes.element,
	redirect: PropTypes.string,
};
AuthRouteWrapper.defaultProps = {
	children: null,
	redirect: '/'
};
